import { defineModule } from './module-utils';

const initialState = {
  modals: [] as ConfirmModal[],
};

export type ConfirmData = {
  text: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

type ConfirmModal = ConfirmData & {
  id: string;
  value: boolean;
  confirm();
  cancel();
}

const modals = defineModule({
  state: initialState,

  getters: {
    confirmModals(state) {
      return state.modals;
    },
  },

  mutations: {
    PUSH_CONFIRM_MODAL_CONTEXT(state, data: ConfirmModal) {
      state.modals.push(data);
    },
    REMOVE_CONFIRM_MODAL_CONTEXT(state, data: ConfirmModal) {
      state.modals = state.modals.filter((d) => d !== data);
    },
  },

  actions: {
    async confirm({ commit, state }, data: ConfirmData) {
      return new Promise<boolean>((resolve) => {
        const context: ConfirmModal = {
          id: String(Math.random()),
          ...data,
          value: true,
          confirm: () => close(true),
          cancel: () => close(false),
        };

        function close(value: boolean) {
          resolve(value);
          const ctx = state.modals.find((d) => d.id === context.id);
          if (ctx) {
            ctx.value = false;
            setTimeout(() => {
              commit('REMOVE_CONFIRM_MODAL_CONTEXT', ctx);
            }, 1000);
          }
        }
        commit('PUSH_CONFIRM_MODAL_CONTEXT', context);
      });
    },
  },
});

export default modals;
